import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "password-fields" }
const _hoisted_2 = { class: "actions md-layout md-alignment-center-space-between" }
const _hoisted_3 = {
  key: 0,
  class: "loading-overlay"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_input = _resolveComponent("md-input")!
  const _component_md_field = _resolveComponent("md-field")!
  const _component_md_progress_spinner = _resolveComponent("md-progress-spinner")!
  const _component_md_content = _resolveComponent("md-content")!

  return (_openBlock(), _createBlock(_component_md_content, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_md_field, {
          style: _normalizeStyle(_ctx.styles.passwordField)
        }, {
          default: _withCtx(() => [
            _createElementVNode("label", null, _toDisplayString(_ctx.t('現在のパスワード')), 1),
            _createVNode(_component_md_input, {
              modelValue: _ctx.state.currentPassword,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.currentPassword) = $event)),
              type: "password"
            }, null, 8, ["modelValue"])
          ], undefined, true),
          _: 1
        }, 8, ["style"]),
        _createVNode(_component_md_field, {
          "md-has-password": "",
          style: _normalizeStyle(_ctx.styles.passwordField)
        }, {
          default: _withCtx(() => [
            _createElementVNode("label", null, _toDisplayString(_ctx.t('新しいパスワード')), 1),
            _createVNode(_component_md_input, {
              modelValue: _ctx.state.newPassword,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.newPassword) = $event)),
              type: "password"
            }, null, 8, ["modelValue"])
          ], undefined, true),
          _: 1
        }, 8, ["style"]),
        _createVNode(_component_md_field, {
          "md-has-password": "",
          style: _normalizeStyle(_ctx.styles.passwordField)
        }, {
          default: _withCtx(() => [
            _createElementVNode("label", null, _toDisplayString(_ctx.t('パスワードの確認')), 1),
            _createVNode(_component_md_input, {
              modelValue: _ctx.state.confirmNewPassword,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.confirmNewPassword) = $event)),
              type: "password"
            }, null, 8, ["modelValue"])
          ], undefined, true),
          _: 1
        }, 8, ["style"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.doChangePassword && _ctx.doChangePassword(...args)))
        }, _toDisplayString(_ctx.t('確定')), 1),
        _createElementVNode("button", {
          class: "",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, _toDisplayString(_ctx.t('キャンセル')), 1)
      ]),
      (_ctx.state.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_md_progress_spinner, {
              "md-mode": "indeterminate",
              "md-stroke": 2
            })
          ]))
        : _createCommentVNode("", true)
    ], undefined, true),
    _: 1
  }))
}